import type { IconData } from '@stacksjs/iconify-core'

export const contentDeleteFile: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h8l4 4v2.5A5.5 5.5 0 0 0 6.875 14H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.252 8.07Q11.616 8 12 8a4 4 0 1 1-.748.07M12 13.06l.94.94L14 12.94l-.94-.94l.94-.94L12.94 10l-.94.94l-.94-.94L10 11.06l.94.94l-.94.94L11.06 14z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentDeleteFile
